export default "Gå i jæger- og samlerfolkets fodspor og sank selv muslinger eller østers langs kysten – præcis som i jægerstenalderen!";